import request from '../utils/request.js'
export function getJson(){
  return request({
    url:'../../static/js/citys.js',
    method: 'get',
  })
}
//获取省市区地址
export function getGeoData() {
  return request({
    url: process.env.MYURL +'/separation/getLinkageAddress',
    method: 'get',
  })
}
//获取三级联动地址等级联动
export function getGeoThreeData() {
  return request({
    url: process.env.MYURL +'/separation/getThreeLinkageAddress',
    method: 'get',
  })
}

//获取二级联动地址等级联动
export function getGeoTwoData() {
  return request({
    url: process.env.MYURL +'/separation/getTwoLinkageAddress',
    method: 'get',
  })
}
//通过三级地址获取四级地址
export function getGeoFourData(query) {
  return request({
    url: process.env.MYURL +'/separation/getFourAddress',
    method: 'get',
    params : query
  })
}
//获取用户所有地址
export function getAddressList(query) {
  return request({
    url: process.env.MYURL + '/separation/getUserAddress',
    method: 'get',
    params: query
  })
}
// export function getAddressList(query) {
//   return request({
//     url: process.env.MYURL + '/separation/getUserAddressNew',
//     method: 'get',
//     params: query
//   })
// }
//删除地址
export function delAddress(query) {
  return request({
    url: process.env.MYURL +'/separation/delUserAddress',
    method: 'get',
    params: query
  })
}
//新增/编辑地址
export function addAddress(query) {
  return request({
    url: process.env.MYURL+ '/separation/addUpdateAddress',
    method: 'post',
    data: query
  })
}

//只增加经纬度的地址编辑
export function updateAddressByUaId(query) {
  return request({
    url: process.env.MYURL+ '/separation/updateAddressByUaId',
    method: 'post',
    data: query
  })
}

//新增/编辑地址 新接口
export function addAddressNew(query) {
  return request({
    url: process.env.MYURL+ '/separation/addUpdateAddressNew',
    method: 'post',
    data: query
  })
}

//获取单个地址
export function getAddressById(query) {
  return request({
    url: process.env.MYURL + '/separation/getUserAddressByUaid',
    method: 'get',
    params: query
  })
}
//校验该地址是否可用
export function checkAddress(query){
  return request({
    url: process.env.NODE_ENV == 'development'? '/address/checkAddress' : process.env.MYURL +  '/address/checkAddress',
    method: 'post',
    params: query
  })
}
//逆地址解析用经纬度解析出详细地址
export function getLocationByCode(query){
  return request({
    // url: process.env.MYURL + '/separation/geocoder' + '?params=' + encodeURIComponent('location=' + query.location + '&key=' + query.key + '&get_poi=' + query.get_poi),
    url: process.env.MYURL + '/separation/geocoder',
    method: 'get',
    params: query
  })
}

//逆地址解析用经纬度解析出详细地址
export function getDetailsAddress(query){
  return request({
    // url: process.env.MYURL + '/separation/geocoder' + '?params=' + encodeURIComponent('location=' + query.location + '&key=' + query.key + '&get_poi=' + query.get_poi),
    url: process.env.MYURL + '/separation/getDetailsAddress',
    method: 'get',
    params: query
  })
}



//通过详细地址获取省市区code
export function getLocalCode(query) {
  return request({
    url: process.env.MYURL + '/separation/calculateTown',
    method: 'post',
    data: query
  })
}



//设为默认地址
export function setDefault(query) {
  return request({
    url: process.env.MYURL + '/separation/sda',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/address.js